const projectPage = {
  "byb360.page.matches.title": "Partidos",
  "byb360.page.match.title": "Partido",
  "byb360.matches.empty": "No se encontraron partidos",
  "byb360.matches.import": "Importar",
  "byb360.matches.draw": "Empate",
  "byb360.matches.won": "Ganado",
  "byb360.matches.lost": "Perdido",
  "byb360.matches.week": "Semana",

  // Projects Index
  "byb360.project.edit.project": "Editar Proyecto",
  "byb360.project.create.project": "Crear Proyecto",
  "byb360.project.name": "Nombre del Proyecto",
  "byb360.project.add.project.name": "Ingresar nombre del proyecto",
  "byb360.project.source": "Fuente",
  "byb360.project.choose.source": "Elegir fuente",
  "byb360.project.local.file": "Archivo local",
  "byb360.project.cloud.match": "Partido en la nube",
  "byb360.project.description": "Descripción",
  "byb360.project.empty": "Descripción opcional",
  "byb360.project.comment": "Comentario",
  "byb360.project.archive.project": "Archivar proyecto",
  "byb360.project.preparing.project": "Preparando proyecto...",
  "byb360.project.upload.files": "Subir Archivos",
  "byb360.project.add.files": "Agregar {{files}} archivos para importar los datos del proyecto.",
  "byb360.project.selected.files": "Archivos seleccionados ({{files}})",
  "byb360.project.detecting.format": "Detectando formato",
  "byb360.project.complete": "Completo",
  "byb360.project.error": "Error",
  "byb360.project.processing": "Procesando...",
  "byb360.project.preparing": "Preparando...",
  "byb360.project.upload": "Subir",
  "byb360.project.data": "datos",
  "byb360.project.and": "y",
  "byb360.project.import.project.data": "Importar datos del proyecto",
  "byb360.project.choose.match.data": "Elegir datos del partido",
  "byb360.project.project.name": "Nombre del Proyecto",
  "byb360.project.created": "Creado",
  "byb360.project.actions": "Acciones",
  "byb360.project.delete.project": "Eliminar Proyecto",
  "byb360.project.delete.confirmation": "¿Estás seguro de que quieres eliminar el siguiente proyecto?",
  "byb360.project.delete.warning": "Esta acción no se puede deshacer. Todos los datos de seguimiento y carpetas asociadas también se eliminarán.",
  "byb360.project.deleting": "Eliminando...",
  "byb360.project.clear.local.data": "Limpiar Datos de Seguimiento Locales",
  "byb360.project.reprocess.data": "Reprocesar Datos de Seguimiento",
  "byb360.project.reprocessing": "Reprocesando...",
  "byb360.project.default.folder.name": "Mis Clips",
  "byb360.project.search.placeholder": "Buscar proyectos...",

  // Clip Context
  "byb360.clip.context.default.name": "Nuevo Clip",
  "byb360.clip.context.title": "Clip de Línea de Tiempo",
  "byb360.clip.context.save": "Guardar",
  "byb360.clip.context.download": "Descargar",
  "byb360.clip.context.name": "Nombre",
  "byb360.clip.context.folder": "Carpeta",
  "byb360.clip.context.select.folder": "Seleccionar una carpeta",
  "byb360.clip.context.status": "Estado",
  "byb360.clip.context.status.published": "Publicado",
  "byb360.clip.context.status.generated": "Generado",
  "byb360.clip.context.status.selected": "Seleccionado",
  "byb360.clip.context.start.end": "Inicio / Fin",
  "byb360.clip.context.duration": "Duración",
  "byb360.clip.context.player": "Jugador",
  "byb360.clip.context.generate.clip.to.select.player": "Generar clip para seleccionar jugador",
  "byb360.clip.context.set.player": "Establecer Jugador",
  "byb360.clip.context.note": "Nota",
  "byb360.clip.context.enter.clip.name": "Ingrese el nombre del clip...",
  "byb360.clip.context.enter.note": "Ingrese una nota...",
  "byb360.clip.context.select.player": "Seleccionar un jugador",
  "byb360.clip.context.loading.players": "Cargando jugadores...",

  // Folder Explorer
  "byb360.folder.explorer.folders": "Carpetas",
  "byb360.folder.explorer.no.folders": "Aún no hay carpetas",
  "byb360.folder.explorer.create.first.folder": "Crea tu primera carpeta para organizar tus escenarios",
  "byb360.folder.explorer.shared.folders": "Carpetas Compartidas",
  "byb360.folder.explorer.no.shared.folders": "No hay carpetas compartidas entre {{ projects }}",
  "byb360.folder.create.error.title": "Error al crear la carpeta",
  "byb360.folder.create.error.subtitle": "Por favor intenta de nuevo o contacta soporte",

  // Empty Context
  "byb360.empty.context.no.selection": "Sin Selección",
  "byb360.empty.context.select.folder.or.timeline":
    "Selecciona una carpeta del explorador o haz una selección en la línea de tiempo para ver información contextual aquí.",

  // Context Row
  "byb360.context.row.add.note": "Agregar una nota...",

  // Match Timeline
  "byb360.timeline.search.events": "Buscar eventos...",
  "byb360.timeline.search.results": "resultados",
  "byb360.timeline.generate.clip": "Generar Clip",
  "byb360.timeline.start": "Inicio:",
  "byb360.timeline.end": "Fin:",
  "byb360.timeline.duration": "Duración:",

  // Event Offset
  "byb360.timeline.event.offset.title": "Desplazamiento de Tiempo de Eventos",
  "byb360.timeline.event.offset.tooltip": "Desplazamiento de Eventos: {{offset}}",
  "byb360.timeline.event.offset.description":
    "Desplaza todos los eventos para corregir problemas de sincronización. Usa el deslizador para ajustes rápidos o ingresa valores precisos abajo.",
  "byb360.timeline.event.offset.available.range": "Rango disponible: {{min}} a {{max}}",
  "byb360.timeline.event.offset.no.events": "No hay eventos disponibles para desplazar",
  "byb360.timeline.event.offset.backward": "Hacia Atrás",
  "byb360.timeline.event.offset.forward": "Hacia Adelante",
  "byb360.timeline.event.offset.visual.control": "Control Visual de Desplazamiento",
  "byb360.timeline.event.offset.current": "Desplazamiento actual: {{offset}}",
  "byb360.timeline.event.offset.minutes": "Minutos",
  "byb360.timeline.event.offset.seconds": "Segundos",
  "byb360.timeline.event.offset.milliseconds": "Milisegundos",
  "byb360.timeline.event.offset.value": "Valor de desplazamiento",
  "byb360.timeline.event.offset.unit.minutes": "min",
  "byb360.timeline.event.offset.unit.seconds": "seg",
  "byb360.timeline.event.offset.unit.milliseconds": "ms",
  "byb360.timeline.event.offset.first.half": "1er Tiempo",
  "byb360.timeline.event.offset.second.half": "2do Tiempo",
  "byb360.timeline.event.offset.kickoff.time": "Tiempo de Inicio del 2do Tiempo",
  "byb360.timeline.event.offset.kickoff.time.description":
    "Establece cuándo comienza el segundo tiempo para habilitar desplazamientos de eventos separados para cada tiempo. Este valor se guarda localmente en tu navegador y es necesario para ajustar el tiempo de los eventos.",
  "byb360.timeline.event.offset.kickoff.time.required": "El tiempo de inicio del 2do tiempo es requerido",
  "byb360.timeline.event.offset.kickoff.time.placeholder": "ej., 45:30",
  "byb360.timeline.event.offset.warning.no.kickoff":
    "Se detectaron desplazamientos de eventos para este proyecto, pero no se ha establecido un tiempo de inicio. Por favor, establece el tiempo de inicio del 2do tiempo para habilitar los ajustes adecuados del tiempo de eventos.",
  "byb360.timeline.event.offset.error.title": "Error al actualizar desplazamientos de eventos",
  "byb360.timeline.event.offset.error.subtitle": "Por favor intenta de nuevo o contacta soporte si el problema persiste",

  // Validation Messages
  "byb360.validation.select.folder": "Por favor selecciona una carpeta para guardar el clip",
  "byb360.validation.generate.clip": "Por favor genera un clip primero haciendo clic en el botón + en la línea de tiempo",
  "byb360.validation.set.player":
    'Por favor establece un jugador en el constructor de escenarios haciendo doble clic en un jugador y seleccionando "Establecer Jugador"',
  "byb360.validation.requirements.before.saving": "Por favor {{requirements}} antes de guardar",

  // Clip Preview Modal
  "byb360.clip.preview.title": "Vista Previa del Clip:",
  "byb360.clip.preview.saved.clip": "Clip Guardado",

  // Cascading Submenu
  "byb360.submenu.select.all": "Seleccionar Todo",
  "byb360.submenu.deselect.all": "Deseleccionar Todo",
  "byb360.submenu.of": "de",
  "byb360.submenu.selected": "seleccionado",
  "byb360.submenu.no.items.available": "No hay elementos disponibles",

  // Folder Context
  "byb360.folder.context.enter.folder.name": "Ingrese el nombre de la carpeta",
  "byb360.folder.context.clips": "Clips guardados",
  "byb360.folder.context.no.clips": "Aún no hay clips",
  "byb360.folder.context.projects": "Proyectos",
  "byb360.folder.context.no.projects": "Sin proyectos",
  "byb360.folder.context.add.to.playlist": "Agregar a lista de reproducción",
  "byb360.folder.context.update": "Actualizar",
  "byb360.folder.context.delete.confirmation": "¿Estás seguro de que quieres eliminar esta carpeta?",
  "byb360.folder.context.start.time": "Inicio",
  "byb360.folder.context.end.time": "Fin",
  "byb360.folder.context.period.1.offset": "Desfase P1",
  "byb360.folder.context.period.2.offset": "Desfase P2",

  // Player selection
  "byb360.player.name.default": "Jugador {id}",

  // File Import Validation
  "byb360.project.import.warning.multiple.formats":
    "Se detectaron múltiples formatos de datos: {{formats}}. Esto puede causar problemas de procesamiento.",
  "byb360.project.import.error.requires.single": "Este archivo requiere un archivo {{format}}",
  "byb360.project.import.error.requires.multiple": "Este archivo requiere archivos {{formats}}",
  "byb360.project.import.error.unsupported.format": "Formato de archivo no compatible",
  "byb360.project.import.fix.errors": "Por favor corrige todos los errores antes de continuar",

  // Multi-Project Menu
  "byb360.multi-project.no.projects": "No hay proyectos seleccionados",
  "byb360.multi-project.tooltip": "Haz clic para cambiar de proyecto",
  "byb360.multi-project.multiple.tooltip": "Múltiples proyectos seleccionados - haz clic para gestionar",

  // Multi-Project Selector
  "byb360.multi-project.selector.title": "Gestor de Proyectos",
  "byb360.multi-project.selector.active": "Proyectos Activos",
  "byb360.multi-project.selector.create.shared.folder": "Crear Carpeta Compartida",
  "byb360.multi-project.selector.add": "Agregar Proyectos",
  "byb360.multi-project.selector.search": "Buscar proyectos...",
  "byb360.multi-project.selector.loading": "Cargando proyectos...",
  "byb360.multi-project.selector.no.results": "No se encontraron proyectos",
  "byb360.multi-project.selector.no.available": "No hay proyectos disponibles",
  "byb360.multi-project.selector.remove": "Eliminar proyecto",

  // Multi-Project Folder Operations
  "byb360.multi-project.folder.created.title": "Carpeta compartida creada exitosamente",
  "byb360.multi-project.folder.created.subtitle": "Los clips guardados en esta carpeta se compartirán entre todos los Proyectos asociados",
  "byb360.multi-project.folder.create.error": "Error al crear la carpeta compartida",
  "byb360.multi-project.folder.project.added": "Proyecto agregado a la carpeta exitosamente",
  "byb360.multi-project.folder.project.add.error": "Error al agregar el proyecto a la carpeta",
  "byb360.multi-project.folder.project.removed": "Proyecto eliminado de la carpeta exitosamente",
  "byb360.multi-project.folder.project.remove.error": "Error al eliminar el proyecto de la carpeta",

  // Playlist Dropdown
  "byb360.playlist.dropdown.create.new.playlist": "Crear nueva lista de reproducción",
  "byb360.playlist.dropdown.no-playlists-found": "No se encontraron listas de reproducción",
  "byb360.playlist.dropdown.no-recent-playlists": "No hay listas de reproducción recientes",
  "byb360.playlist.dropdown.search.placeholder": "Buscar listas de reproducción...",
  "byb360.playlist.dropdown.error.publish-scenario.title": "Error al publicar escenario",
  "byb360.playlist.dropdown.error.publish-scenario.message": `Error al publicar escenario "{{name}}". Puedes intentar agregarlo nuevamente a una lista de reproducción o publicarlo manualmente en el Constructor de Escenarios. De lo contrario, por favor contacta soporte.`,
  "byb360.playlist.dropdown.error.update-playlist.title": "Error al actualizar lista de reproducción",
  "byb360.playlist.dropdown.error.update-playlist.message": "Por favor intenta de nuevo o contacta soporte.",
};

export const byb360 = {
  ...projectPage,
};
